import "./BulletListCallOut.scss";
import { ReactNode } from "react";

interface Props {
  children: ReactNode | ReactNode[];
}

const BulletListCallOut = ({ children }: Props) => (
  <ul className="bullet-list-call-out">{children}</ul>
);

export default BulletListCallOut;
